import { render, staticRenderFns } from "./EmotionStats.vue?vue&type=template&id=352c802a&scoped=true"
import script from "./EmotionStats.vue?vue&type=script&lang=js"
export * from "./EmotionStats.vue?vue&type=script&lang=js"
import style0 from "./EmotionStats.vue?vue&type=style&index=0&id=352c802a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c802a",
  null
  
)

export default component.exports